
const steps = [
  "ایجاد نسخه و ارسال",
 "در انتظار تایید و اعلام قیمت",
  "آماده‌سازی",
"هماهنگی جهت تحویل" ,
  "تحویل سفارش",
];

function PrescriptionStepper({ currentStep = 1 }) {
  return (
    <ol className="pc-stepper" dir="rtl">
      {steps.map((label, index) => {
        const stepNumber = index + 1;

        const isDone = currentStep > stepNumber;
        const isCurrent = currentStep === stepNumber;

        return (
          <li
            key={stepNumber}
            className={[
              isDone ? "is-done" : "",
              isCurrent ? "is-current" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            <span className="pc-stepper__number">
              {isDone ? "✓" : stepNumber}
            </span>

            <span className="pc-stepper__label">
              {label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}

export default PrescriptionStepper;
